export default "__VITE_ASSET__D5QXdOY7__"